const PROCESS_INTERVAL = 100;
const DEBOUNCE_WINDOW_WIDTH = 500;

export enum EventType {
  Navigation = 0,
  UserEvent = 1
}

interface TimerEvent {
  callback: Function;
  type: EventType;
}
class TimerQueue {
  private eventQueue: TimerEvent[] = [];

  private debounceWindowStart: number = 0;

  private static instance: TimerQueue;

  static getInstance = (): TimerQueue => {
    if (!TimerQueue.instance) {
      TimerQueue.instance = new TimerQueue();
    }
    return TimerQueue.instance;
  };

  init() {
    setInterval(() => this.processQueue(), PROCESS_INTERVAL);
  }

  addEvent(event: TimerEvent) {
    if (event.type !== EventType.Navigation) {
      this.resetDebounceStart();
    }
    this.eventQueue.push(event);
  }

  resetDebounceStart() {
    this.debounceWindowStart = new Date().getTime();
  }

  processQueue() {
    this.eventQueue = this.eventQueue.filter(event => {
      if (event.type === EventType.Navigation) {
        if (!this.shouldFireNavigationEvent()) {
          return true;
        }
      }
      event.callback();
      return false;
    });
  }

  shouldFireNavigationEvent(): boolean {
    const currTime = new Date().getTime();
    return currTime > this.debounceWindowStart + DEBOUNCE_WINDOW_WIDTH;
  }
}

export default TimerQueue.getInstance();
